import { createAsyncAction } from 'typesafe-actions';

import type { LeadHydrationConfig } from '@portal/api-models';

import type { IsomorphicRequestPayload } from '../types';

import { LeadHydrationActionType } from './actionTypes';
import type {
  CreateCreditCardLeadHydrationRequestPayload,
  DeleteCreditCardLeadHydrationRequestPayload,
  GetBySubAccountUuidRequestPayload,
  GetBySubAccountUuidResponsePayload,
} from './types';

export const getLeadHydrationConfigsBySubAccountUuidAction = createAsyncAction(
  LeadHydrationActionType.GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_REQUEST,
  LeadHydrationActionType.GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_SUCCESS,
  LeadHydrationActionType.GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_FAILURE
)<
  GetBySubAccountUuidRequestPayload,
  GetBySubAccountUuidResponsePayload,
  Error
>();

export const createLeadHydrationConfigAction = createAsyncAction(
  LeadHydrationActionType.CREATE_LEAD_HYDRATION_CONFIG_REQUEST,
  LeadHydrationActionType.CREATE_LEAD_HYDRATION_CONFIG_SUCCESS,
  LeadHydrationActionType.CREATE_LEAD_HYDRATION_CONFIG_FAILURE
)<
  Partial<LeadHydrationConfig> & IsomorphicRequestPayload,
  LeadHydrationConfig,
  Error
>();

export const createCreditCardLeadHydrationConfigAction = createAsyncAction(
  LeadHydrationActionType.CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_REQUEST,
  LeadHydrationActionType.CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_SUCCESS,
  LeadHydrationActionType.CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_FAILURE
)<CreateCreditCardLeadHydrationRequestPayload, LeadHydrationConfig, Error>();

export const deleteCreditCardLeadHydrationConfigAction = createAsyncAction(
  LeadHydrationActionType.DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_REQUEST,
  LeadHydrationActionType.DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_SUCCESS,
  LeadHydrationActionType.DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_FAILURE
)<DeleteCreditCardLeadHydrationRequestPayload, any, Error>();
